import { getBankIcon } from '@/globalFunctions/functions'

const state = {
  userCards: [],
  selectedCard: {}
};

const getters = {}

const actions = {
  prepareCardsInfo: ({ commit }, userCards) => {
    for (let i = 0; i < userCards.length; i++) {
      const binCode = userCards[i].pan.split('*');
      userCards[i].iconPath = getBankIcon(binCode[0]);
      userCards[i].cardUserCode = binCode[6];
    }
    commit('saveUserCards', userCards);
  }
};

const mutations = {
  saveUserCards: (state, data) => {
    state.userCards = data
  },
  saveSelectedCard: (state, data) => { state.selectedCard = data }
};

export default {
  state,
  getters,
  actions,
  mutations
}
;
